import baseAPI from '@/api/base';
import { EditBillingInvoicing, GetBillingInvoicing, RegisterBillingInvoicing } from '@/dtos/billing_invoicing.dto';
import {
  DELETE_BILLING_AND_INVOICING_URL,
  DOWNLOAD_INVOICE_PDF_URL,
  EDIT_BILLING_AND_INVOICING_URL,
  GET_BILLING_AND_INVOICING_URL,
  GET_BILLING_AND_INVOICING_STATS_URL,
  REGISTER_BILLING_AND_INVOICING_URL,
  TOGGLE_BILLING_AND_INVOICING_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class BillingInvoicing {
  static getBillingInvoicings = async (getBillingInvoicing: GetBillingInvoicing): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BILLING_AND_INVOICING_URL, {
      params: getBillingInvoicing,
    });
    console.log('response', response);
    return response;
  };

  static registerBillingInvoicing = async (
    registerBillingInvoicing: RegisterBillingInvoicing
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_BILLING_AND_INVOICING_URL, {
      ...registerBillingInvoicing,
    });
    console.log('response', response);
    return response;
  };

  static editBillingInvoicing = async (editBillingInvoicing: EditBillingInvoicing): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_BILLING_AND_INVOICING_URL, {
      ...editBillingInvoicing,
    });
    return response;
  };

  static toggleBillingInvoicingIsActive = async (
    editBillingInvoicing: EditBillingInvoicing
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_BILLING_AND_INVOICING_IS_ACTIVE_URL,
      {
        ...editBillingInvoicing,
      }
    );
    return response;
  };

  static getBillingInvoicingStats = async (params: { organizationId: string; projectId?: string }): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BILLING_AND_INVOICING_STATS_URL, {
      params,
    });
    return response;
  };

  static deleteBillingInvoicing = async (billingInvoicingId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_BILLING_AND_INVOICING_URL}/${billingInvoicingId}`
    );
    return response;
  };

  static downloadInvoicePDF = async (invoiceId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      `${DOWNLOAD_INVOICE_PDF_URL}/${invoiceId}/pdf`,
      {
        responseType: 'blob',
      }
    );
    return response;
  };
}

export default BillingInvoicing;

